import { route, tag, type PageTour } from '../pageTour';

export const modelAssignmentsTour: PageTour = {
  id: 'page-model-assignments',
  version: 1,
  title: 'Model Assignments',
  summary: 'Choose which AI models run on which cameras.',
  match: route('/model-assignments'),
  steps: [
    {
      target: tag('assign-legend'),
      title: 'How it works',
      description: 'A model set on a group runs on every camera in it. A model set on a single camera runs on that camera only.',
      side: 'bottom',
    },
    {
      target: tag('assign-groups'),
      title: 'Group list',
      description: 'Click a model under a group to switch it on or off for the whole group. Click the group name to show only its cameras.',
      side: 'right',
    },
    {
      target: tag('assign-camera-search'),
      title: 'Find a camera',
      description: 'Search by camera name, address or location.',
      side: 'bottom',
    },
    {
      target: tag('assign-cameras'),
      title: 'Camera list',
      description: 'Switch models on or off for one camera. Models with a lock come from the camera’s group and are changed there.',
      side: 'left',
    },
    {
      target: tag('assign-save'),
      title: 'Save changes',
      description: 'Nothing is applied until you save. Use Discard to undo your edits.',
      side: 'bottom',
      permission: 'ai-models.assign',
    },
  ],
};
